import { DateFormats, formatDate } from '@strata/helper-functions';
import { InfoDialog } from '@strata/react-dialog';
import { Spinner } from '@strata/react-loading-animation';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

import { useGetAuditLogEventJSONQuery } from 'store/api/treatmentAuditApi';

export const ViewRawAuditLogDialog = ({
    isOpen,
    onClose,
    logId = undefined,
    title = undefined,
    timestamp = undefined,
}) => {
    const { data, isLoading, isError } = useGetAuditLogEventJSONQuery(
        { logId },
        {
            skip: !isOpen || !logId,
        },
    );

    useEffect(() => {
        if (isError) {
            onClose();
        }
    }, [isError, onClose]);

    const formattedTimestamp = formatDate(timestamp, DateFormats.DATE_TIME);

    return (
        <InfoDialog
            dialogTitle={`${title} - ${formattedTimestamp}`}
            isOpen={isOpen}
            dialogContent={
                isLoading ? (
                    <Spinner className="padding__around--large" size={Spinner.Size.LARGE} />
                ) : (
                    <div style={{ wordWrap: 'normal', overflowX: 'scroll' }}>
                        {data && <pre>{JSON.stringify(data, null, 2)}</pre>}
                    </div>
                )
            }
            onClose={onClose}
            width={750}
        />
    );
};

ViewRawAuditLogDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    logId: PropTypes.string,
    title: PropTypes.string,
    timestamp: PropTypes.string,
};
